
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_s3s4z_97",
  "trigger": "awsui_trigger_14cnr_s3s4z_134",
  "dropdown": "awsui_dropdown_14cnr_s3s4z_137",
  "nowrap": "awsui_nowrap_14cnr_s3s4z_148",
  "open": "awsui_open_14cnr_s3s4z_151"
};
  